window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.favoritesRepo = function () {
    var url = 'api/favorites';

    var create = function (igra) {
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(igra)
        })
        .then(casino.repos.base.checkResponse)
        .catch(casino.repos.base.handleNetworkException);
    };

    var remove = function (igra) {
        return fetch(url, {
            method: 'DELETE',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(igra)
        })
        .then(casino.repos.base.checkResponse)
        .catch(casino.repos.base.handleNetworkException);
    };

    return {
        create: create,
        remove: remove
    }

}();